export const availableLanguages = () => process.env.VUE_APP_AVAILABLE_LANGUAGES.split(',')